<template>
  <div>
    
    <div v-if="!isLoading">
     
      <div class="box-card" style="margin-top: 30px" shadow="never">
        <el-tabs
          v-model="activeName"
          type="card"
          tab-position="left"
          :before-leave="onBeforeLeave"
          class="main-tab-container"
        >
          <el-tab-pane
            :name="'' + index"
            v-for="(item, index) in lessonPeriodList"
            class="main-tab-pane-container"
          >
            <span slot="label">
              <span> 第{{ index + 1 }}课时</span>
            </span>
            <the-lesson-content
              :period-id="item.id"
              :ref="'content' + index"
            />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <el-dialog
      title="修改课时名称"
      :visible.sync="dialogFormVisible"
      @keyup.enter.native="onSavePeriodName('periodNameForm')"
    >
      <el-form
        :model="periodNameForm"
        :rules="periodRules"
        ref="periodNameForm"
      >
        <el-form-item label="当前名称">
          <label>{{ currentName }}</label>
        </el-form-item>
        <el-form-item label="课时名称" prop="name">
          <el-input
            v-model="periodNameForm.name"
            auto-complete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSavePeriodName('periodNameForm')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TheLessonContent from "./components/TheLessonContent";
import { save, info } from "../../../../api/teacher/lesson";
import BaseExitLayout from "../../../common/BaseExitLayout";
import { getPlanBySchool } from "../../../../api/ruleplan";
import {
  queryLessonPeriod,
  save as savePeriod,
  deleteObj,
  update as updatePeriod
} from "../../../../api/teacher/lessonperiod";
import { getTeacherRes } from "../../../../api/course";
import { queryRuleCoursePeriod, saveRuleCoursePeriod, updateRuleCoursePeriod, deleteRuleCoursePeriod, saveRuleCousePeriodList} from "../../../../api/RuleCourse";
export default {
  name: "lesson-add-or-update",
  components: { BaseExitLayout, TheLessonContent },
  data() {
    return {
      loading: false,
      isLoading: true,
      lessonPeriodList2: [],
      lessonId: undefined,
      ruleCourseId: undefined,
      courseRes: undefined,
      dialogFormVisible: false,
      currentName: undefined,
      currentPeriodId: undefined,
      currentPeriodIndex: undefined,
      isShouldBack: false,
      currentTabIndex: 0,
      textMap: [
        "第一个课时",
        "第二个课时",
        "第三个课时",
        "第四个课时",
        "第五个课时",
        "第六个课时",
        "第七个课时",
        "第八个课时",
        "第九个课时",
        "第十个课时"
      ],
      rules: {
        title: [{ required: true, message: "请输入备课内容", trigger: "blur" }]
      },
      periodRules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }]
      },
      defaultDta: {
        lessonHomeworkEntity: {
          title: undefined,
          requirement: undefined,
          scoreType: undefined,
          classIdList: undefined,
          dateRegion: undefined
        },
        teacherPlanEntity: {
          title: undefined,
          content: undefined
        },
        teacherCourseWareCategoryVoList: [
          {
            name: "默认分类",
            sort: undefined,
            teacherCourseWareEntityList: [
              {
                title: undefined,
                page: 0,
                content: undefined
              }
            ]
          }
        ]
      },
      activeName: "0",
      plan: {},
      form: {
        id: undefined,
        title: undefined,
        lessonPeriodList: [
          {
            index: 0,
            courseId: undefined,
            ...this.defaultDta
          }
        ],
        type: "type"
      },
      periodNameForm: {
        id: undefined,
        name: undefined
      }
    };
  },
  created() {
    let id = this.$route.query.id;
    let perioidIndex = this.$route.query.pIndex;
    this.lessonId = id;
    this.ruleCourseId = id;
    this.getRuleCoursePeriod();
   // this.getTeacherRes();
  },
  // mounted() {
  //   if (window.history && window.history.pushState) {
  //     // 向历史记录中插入了当前页
  //     history.pushState(null, null, document.URL);
  //     window.addEventListener("popstate", this.onBack, false);
  //   }
  // },
  // destroyed() {
  //   window.removeEventListener("popstate", this.onBack, false);
  // },
  methods: {
    getRuleCoursePeriod() {
      this.isLoading = true;
      queryRuleCoursePeriod(this.ruleCourseId).then(({ data }) => {
          let arr = data.page.list || [];
          arr.forEach(item => {
            item.lessonHomeworkEntity = item.lessonHomeworkEntity || {
              ...this.defaultDta.lessonHomeworkEntity
            };
            item.teacherPlanEntity = item.teacherPlanEntity || {
              ...this.defaultDta.teacherPlanEntity
            };
            item.teacherCourseWareCategoryVoList = item.teacherCourseWareCategoryVoList || {
              ...this.defaultDta.teacherCourseWareCategoryVoList
            };
          });
           this.lessonPeriodList = arr;
           console.log('lesson period', arr)
           this.isLoading = false;
      });
    },
    getTeacherRes() {
      getTeacherRes()
        .then(({ data }) => {
          this.courseRes = data.page;
        })
        .catch(e => {});
    },
    onBack() {
      if (this.isShouldBack) {
        this.$router.go(-1);
        return;
      }
      for (let index in this.lessonPeriodList) {
        let ref = "content" + index;
        let change = this.$refs[ref][0].isChange();

        if (change[0]) {
          this.$confirm(
            `检测到第【${this.textMap[index]}】${change[1]}未保存的内容，导致所有输入内容丢失，要重头再来输入一次？`,
            "确认信息",
            {
              distinguishCancelAndClose: true,
              confirmButtonText: "保存",
              cancelButtonText: "放弃修改"
            }
          )
            .then(action => {
              this.isShouldBack = true;
              this.$refs[ref][0].saveData();
              this.$router.go(-1);
              return;
            })
            .catch(action => {
              if (action === "cancel") {
                this.isShouldBack = true;
                this.$router.go(-1);
                return;
              }
            });
          return;
        }
      }
      this.$router.go(-1);
    },
    onCreate() {
      this.loading = true;
      savePeriod({
        lessonId: this.lessonId,
        classHour: 0
      })
        .then(({ data }) => {
          if (data.code === 0) {
            this.lessonPeriodList.push({
              id: data.data,
              classHour: 0,
              lessonId: this.lessonId,
              ...this.defaultDta
            });
          } else {
            this.$ui.showError(data.msg);
          }
          this.loading = false;
        })
        .catch(e => {
          this.loading = false;
        });
    },
    getLessonPeriod() {
      this.isLoading = true;
      queryLessonPeriod(this.lessonId)
        .then(({ data }) => {
          let arr = data.page.list || [];
          arr.forEach(item => {
            item.lessonHomeworkEntity = item.lessonHomeworkEntity || {
              ...this.defaultDta.lessonHomeworkEntity
            };
            item.teacherPlanEntity = item.teacherPlanEntity || {
              ...this.defaultDta.teacherPlanEntity
            };
            item.teacherCourseWareCategoryVoList = item.teacherCourseWareCategoryVoList || {
              ...this.defaultDta.teacherCourseWareCategoryVoList
            };
          });
          this.lessonPeriodList = arr;
          this.isLoading = false;
          if (arr.length == 0) {
            this.onCreate();
          }
        })
        .catch(e => {
          this.isLoading = false;
        });
    },
    getPlane() {
      getPlanBySchool()
        .then(({ data }) => {
          if (data.code === 0) {
            this.plan = data.data;
            if (!this.form.id) {
              this.form.lessonPeriodList[0].teacherPlanEntity.title = this.plan.name;
              this.form.lessonPeriodList[0].teacherPlanEntity.content = this.plan.content;
            }
          }
        })
        .catch(e => {});
    },
    onEditPage(list, index) {
      this.dialogFormVisible = true;
      this.currentPeriodId = list[index].id;
      this.currentPeriodIndex = index;
    //   if (list[index].name) {
    //     this.currentName = list[index].name;
    //   } else {
    //     this.currentName = "第" + (index + 1) + "课时";
    //   }
    },
    onSavePeriodName() {
      this.periodNameForm.id = this.currentPeriodId;
      updatePeriod(this.periodNameForm)
        .then(({ data }) => {
          if (data.code === 0) {
            this.$ui.showSuccess("保存成功");
            // this.textMap[this.currentPeriodIndex] = this.periodNameForm.name
            //  vm.$set(this.textMap, this.currentPeriodIndex, this.periodNameForm.name)
            //  this.textMap.splice(this.currentPeriodIndex, 1, this.periodNameForm.name)
            //  Vue.set(this.textMap, this.currentPeriodIndex, this.periodNameForm.name)
            //  console.log(this.currentPeriodIndex, 1, this.periodNameForm.name)
            this.textMap.splice(
              this.currentPeriodIndex,
              1,
              this.periodNameForm.name
            );
            var item = this.lessonPeriodList[this.currentPeriodIndex];
            item.name = this.periodNameForm.name;
            this.lessonPeriodList.splice(this.currentPeriodIndex, 1, item);
            this.dialogFormVisible = false;
          } else {
            this.$ui.showError(data.msg);
          }
        })
        .catch(e => {
          this.$ui.showError("修改失败，请检查网络连接");
        });
    },
    onDeletePage(list, index) {
      this.$ui
        .confirm()
        .then(() => {
          //删除课时
          deleteObj(list[index].id)
            .then(({ data }) => {
              if (data.code === 0) {
                list.splice(index, 1);
                this.activeName = "" + (this.lessonPeriodList.length - 1);
              } else {
                this.$ui.showError(data.msg);
              }
            })
            .catch(e => {
              this.$ui.showError("网络错误");
            });
        })
        .catch(e => {});
    },
    getLessonInfo(id) {
      info(id)
        .then(({ data }) => {
          this.form = data.data;
        })
        .catch(e => {});
    },
    saveData(formName, isBack) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          save(this.form)
            .then(({ data }) => {
              if (data.code === 0) {
                if (isBack) {
                  this.$router.go(-1);
                }
              } else {
                this.$ui.showError(data.msg);
              }
            })
            .catch(e => {});
        } else {
          return false;
        }
      });
    },
    onBeforeLeave(activeName) {
      if (activeName === "add") {
        this.handerAdd();
        return false;
      }
      return true;
    },
    handerAdd() {
      savePeriod({
        lessonId: this.lessonId,
        classHour: this.lessonPeriodList.length + 1
      })
        .then(({ data }) => {
          if (data.code === 0) {
            this.lessonPeriodList.push({
              id: data.data,
              classHour: this.lessonPeriodList.length + 1,
              lessonId: this.lessonId,
              ...this.defaultDta
            });
            this.activeName = "" + (this.lessonPeriodList.length - 1);
          } else {
            this.$ui.showError(data.msg);
          }
        })
        .catch(e => {});
    }
  }
};
</script>

<style lang="scss">

.el-tabs__header {
    margin-top: 40px;
    border: 0;
}
.el-tabs__content {
    padding-right: 100px;
}
.el-tabs__nav {
    border: 0;
    margin-bottom: 10px;
}
.el-tabs__item {
    margin-top: 22px;
    box-shadow: 0 3px 5px 0 rgba(140, 140, 140, 0.5);
    border-radius: 8px;
    border-radius: 8px;
    border: 0;
  }
  .el-tabs--card>.el-tabs__header .el-tabs__nav {
      margin-left: 10px;
     border: 0px solid #E4E7ED; 
    border-bottom: none;
    border-radius: 4px 4px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
.el-tabs--left.el-tabs--card .el-tabs__item.is-left.is-active {
    border: 0px solid #E4E7ED;
    background: #4A90E2;
    color: #fff;
}
</style>
